/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.page.html',
  styleUrls: ['./instructions.page.scss']
})
export class InstructionsPage implements OnInit {
  stepName = '';
  isModal: boolean;

  constructor(
    public navParams: NavParams,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController
  ) {}

  dismiss() {
    if (this.isModal) {
      this.modalCtrl.dismiss();
    } else {
      this.popoverCtrl.dismiss();
    }
  }

  ionViewWillEnter() {
    this.stepName = this.navParams.data.stepName;
    this.isModal = this.navParams.data.isModal;
  }

  ngOnInit() {}
}
